import { ACTIONS_TRUCK } from '../_constants/truck.constants';

const initialState = {
  byId: {},
};

export function truckReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_TRUCK.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_TRUCK.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_TRUCK.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default truckReducer;
